import React, { useState, useEffect } from 'react';

const SecondCounter = ({  endDate, onFinish }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(0)

  useEffect(() => {
    const calculateSeconds = () => {
      const now = new Date().getTime();
      const target = new Date(endDate).getTime();
      const difference = Math.floor((target - now) / 1000);
      return difference > 0 ? difference : 0;
    };

    setSecondsRemaining(calculateSeconds());

    const timer = setInterval(() => {
      const remaining = calculateSeconds();
      setSecondsRemaining(remaining);

      if (remaining <= 0) {
        clearInterval(timer);
        onTimerFinish();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  const onTimerFinish = () => {
    console.log("Countdown finished!")
    onFinish("Countdown finished!")
  };

  return (
    <div className='text-center text-info'>
      Faltan {secondsRemaining} segundos {secondsRemaining === 0 && <p>Culminó el test</p>}
    </div>
  );
};

export default SecondCounter;
